import React, { useState } from "react";
import PageSeo from "../../components/seo/PageSeo";
import { Navigate } from "react-router-dom";
import { forgerPassCall } from "../../calls";
import Error from "../../components/Error/Error";
import { useTranslation } from "react-i18next";
import "../../components/login/auth-signal.css";

/* FORGET PASSWORD — design "Signal" */
const ForgetPassword = (props) => {
  const {
    isLoggedIn,
    showErrorModal, setShowErrorModal, setErrorMsg, errorMsg,
    setLoader,
  } = props;
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(false);
    forgerPassCall(email)
      .then(() => {
        setLoader(true);
        setSuccess(t("signal.fp-sent"));
        setEmail("");
      })
      .catch((err) => {
        setLoader(true);
        setShowErrorModal(true);
        // data.email = adresse refusee par le serializer ; sinon message generique
        // (on ne dit pas si l'adresse existe, comme avant)
        setErrorMsg([err?.response?.data?.email ? t("signal.auth-email-invalid") : t("signal.fp-failed")]);
      });
  };

  if (isLoggedIn) return <Navigate replace to="/" />;

  return (
    <div className="sg-page" style={{ maxWidth: 440, minHeight: "60vh", justifyContent: "center" }}>
      <PageSeo noindex title={t("overview.reset-pass")} />
      <div className="sg-panel" style={{ padding: 24 }}>
        <h1 className="sg-h1" style={{ fontSize: 20, marginBottom: 6 }}>
          {t("overview.forget-pass")}
        </h1>
        <p className="sg-sub" style={{ marginBottom: 16 }}>
          {t("signal.fp-sub")}
        </p>
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div className="auth-field">
            <span className="auth-field__label">{t("overview.enter-email")}</span>
            <div className="auth-field__box">
              <input
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                id="email"
                name="email"
                placeholder="you@example.com"
                autoComplete="email"
              />
            </div>
          </div>
          {success && (
            <p className="sg-status sg-status--ok" style={{ fontSize: 13 }}>{success}</p>
          )}
          <button type="submit" className="sg-btn sg-btn--primary" style={{ width: "100%" }}>
            {t("signal.fp-send")}
          </button>
        </form>
      </div>
      <Error
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
        errorMsg={errorMsg}
      />
    </div>
  );
};

export default ForgetPassword;
